var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepFilled = function SvgSleepFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.759191,87.4998187 C30.003191,87.4998187 14.764191,76.9678187 8.83919099,61.2908187 C8.56519099,60.5658187 8.73419099,59.7498187 9.27219099,59.1928187 C9.81119099,58.6368187 10.621191,58.4418187 11.355191,58.6898187 C15.165191,59.9888187 19.132191,60.6468187 23.147191,60.6468187 C43.291191,60.6468187 59.679191,44.2588187 59.679191,24.1148187 C59.679191,19.6828187 58.887191,15.3398187 57.325191,11.2068187 C57.051191,10.4828187 57.220191,9.66481866 57.758191,9.10881866 C58.297191,8.55281866 59.111191,8.35781866 59.841191,8.60681866 C76.259191,14.2048187 87.290191,29.6218187 87.290191,46.9678187 C87.290191,69.3168187 69.108191,87.4998187 46.759191,87.4998187",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgSleepFilled;